import { useStytchAuth } from './useStytchAuth';

/**
 * Authentication Hook
 * 
 * Uses Stytch for authentication with Xano backend integration.
 * Stytch configuration is required for authentication to work.
 */
export const useHybridAuth = () => {
  // Check if Stytch is configured
  const isStytchConfigured = Boolean(
    import.meta.env.VITE_STYTCH_PROJECT_ID && 
    import.meta.env.VITE_STYTCH_PUBLIC_TOKEN
  );
  
  if (!isStytchConfigured) {
    throw new Error('Authentication is not configured. Please set up Stytch environment variables.');
  }
  
  // Use Stytch auth
  const auth = useStytchAuth();
  
  return {
    ...auth,
    // Add hybrid-specific functionality
    isStytchEnabled: true,
    authProvider: 'stytch',
  };
};